module.exports = __webpack_public_path__ + "img/Logo_AJA_white.7d4e3f6d.png";